import React, { ReactNode } from 'react';
import { Typography } from 'antd';
import styled from 'styled-components';

type FlexibleDetailsHeaderLayoutProps = {
  title?: ReactNode;
  actions: ReactNode;
  className?: string;
  rootTestId?: string;
  titleTestId?: string;
  actionsTestId?: string;
};

const HeaderRoot = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px 24px;
  padding-bottom: 20px;
  margin-bottom: 24px;
  border-bottom: 1px solid #dce4ed;

  @media (max-width: 991px) {
    margin-bottom: 16px;
  }
`;

const HeaderTitle = styled.div`
  flex: 1 1 420px;
  min-width: 0;
  overflow-wrap: anywhere;
  .ant-typography {
    margin: 0;
    font-size: 24px;
    line-height: 1.4;
    letter-spacing: -0.4px;
  }
  .ant-breadcrumb ol {
    align-items: baseline;
  }
  .ant-breadcrumb li:last-child {
    min-width: 0;
  }
`;

const HeaderActions = styled.div`
  display: flex;
  flex: 0 1 auto;
  justify-content: flex-end;
  margin-left: auto;
  min-width: 0;
  max-width: 100%;

  @media (max-width: 991px) {
    width: 100%;
    min-width: 0;
    justify-content: flex-start;
    margin-left: 0;
  }
`;

export const FlexibleDetailsHeaderLayout: React.FC<FlexibleDetailsHeaderLayoutProps> = ({
  title,
  actions,
  className,
  rootTestId,
  titleTestId,
  actionsTestId,
}) => {
  return (
    <HeaderRoot className={className} data-testid={rootTestId}>
      <HeaderTitle data-testid={titleTestId}>
        {typeof title === 'string' ? <Typography.Title level={3}>{title}</Typography.Title> : title}
      </HeaderTitle>
      <HeaderActions data-testid={actionsTestId}>{actions}</HeaderActions>
    </HeaderRoot>
  );
};
